export type ValidationError = {
  field: string;
  message: string;
};

export const validateForm = (formData: any, schema: any): ValidationError[] => {
  const errors: ValidationError[] = [];

  Object.entries(schema).forEach(([field, rules]: [string, any]) => {
    const value = formData[field];

    if (rules.required && !value) {
      errors.push({
        field,
        message: `${field.replace('_', ' ')} is required`,
      });
      return;
    }

    if (value) {
      if (rules.minLength && value.length < rules.minLength) {
        errors.push({
          field,
          message: `${field.replace('_', ' ')} must be at least ${rules.minLength} characters`,
        });
      }

      if (rules.maxLength && value.length > rules.maxLength) {
        errors.push({
          field,
          message: `${field.replace('_', ' ')} must be less than ${rules.maxLength} characters`,
        });
      }

      if (rules.pattern && !rules.pattern.test(value)) {
        errors.push({
          field,
          message: `${field.replace('_', ' ')} is invalid`,
        });
      }

      if (rules.validator && !rules.validator(value, formData)) {
        errors.push({
          field,
          message: `${field.replace('_', ' ')} is invalid`,
        });
      }
    }
  });

  return errors;
}; 


export const convertToSnakeCase = (input: string): string => {
  return input
    .replace(/([A-Z])/g, '_$1')  // Convert camelCase to snake_case
    .toLowerCase()
    // Replace spaces and special characters with underscores
    .replace(/[^a-z0-9_-]/g, '_')
    // Remove consecutive underscores
    .replace(/_+/g, '_')
    // Remove leading/trailing underscores
    .replace(/^_|_$/g, '');
};